import React from 'react';

interface LetterListInputProps {
  value: string;
  onChange: (value: string) => void;
  label: string;
  placeholder: string;
  maxLength?: number;
}

export const LetterListInput: React.FC<LetterListInputProps> = ({
  value,
  onChange,
  label,
  placeholder,
  maxLength = 26,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const cleanValue = e.target.value
      .toUpperCase()
      .replace(/[^A-Z]/g, '')
      .split('')
      .filter((letter, index, arr) => arr.indexOf(letter) === index)
      .join('')
      .slice(0, maxLength);
    onChange(cleanValue);
  };

  return (
    <div style={{ marginBottom: '16px', textAlign: 'center' }}>
      <label style={{
        display: 'block',
        marginBottom: '6px',
        fontSize: '12px',
        fontWeight: 600,
        color: '#818384',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
      }}>
        {label}
      </label>
      <input
        type="text"
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        style={{
          width: '100%',
          maxWidth: '300px',
          padding: '10px 12px',
          fontSize: '16px',
          fontWeight: 600,
          border: '2px solid #3a3a3c',
          borderRadius: '6px',
          backgroundColor: '#121213',
          color: '#fff',
          textTransform: 'uppercase',
          letterSpacing: '3px',
          boxSizing: 'border-box',
          outline: 'none',
          transition: 'border-color 0.15s',
        }}
        onFocus={(e) => { e.target.style.borderColor = '#565758'; }}
        onBlur={(e) => { e.target.style.borderColor = '#3a3a3c'; }}
      />
      {value.length > 0 && (
        <div style={{ fontSize: '11px', color: '#565758', marginTop: '4px', letterSpacing: '1px' }}>
          {value.split('').join(' · ')}
        </div>
      )}
    </div>
  );
};
